import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { PrimaryButton, ClearButton } from 'ui/Components';

import styles from './UnsavedChangesConfirmationModal.css';

/**
 * Returns a Modal to confirm the user action on unsaved page or component.
 * @returns {React.Component} Modal to show the confirmation dialog
 */
const UnsavedChangesConfirmationModal = ({
  onCancel,
  onDiscard,
  onSave,
  showUnsavedChangesConfirmation
}) => (
  <Modal isOpen={showUnsavedChangesConfirmation} toggle={onCancel}>
    <ModalHeader>Save Changes</ModalHeader>
    <ModalBody>
      <div className="pb-3">Do you want to save your changes before you leave?</div>
      <div className={classnames(styles.buttonWrapper, 'pb-3')}>
        <ClearButton
          onClick={onDiscard}
          data-test-id="unsavedChangesConfirmationModal-discardButton"
        >
          No, Discard Changes
        </ClearButton>
        <PrimaryButton
          onClick={onSave}
          data-test-id="unsavedChangesConfirmationModal-savePage"
        >
          Yes, Save Changes
        </PrimaryButton>
      </div>
    </ModalBody>
  </Modal>
);

UnsavedChangesConfirmationModal.propTypes = {
  onCancel: propTypes.func.isRequired,
  onDiscard: propTypes.func.isRequired,
  onSave: propTypes.func.isRequired,
  showUnsavedChangesConfirmation: propTypes.bool
};

UnsavedChangesConfirmationModal.defaultProps = { showUnsavedChangesConfirmation: false };

export default UnsavedChangesConfirmationModal;
